import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { BottomFooter } from '..';

import { MainContainer, LayoutChildren } from './Layout.style';

// menu will be default to true if we decide to add it in every page
const Layout = ({
  children,
  footer = true,
  menu = false,
  type,
  footerType
}) => {
  return (
    <Fragment>
      <MainContainer type={type}>
        <LayoutChildren menu={menu}>{children}</LayoutChildren>
      </MainContainer>
      {footer && <BottomFooter footerType={footerType} />}
    </Fragment>
  );
};

Layout.propTypes = {
  children: PropTypes.node,
  header: PropTypes.bool,
  footer: PropTypes.bool,
  menu: PropTypes.bool,
  type: PropTypes.string,
  footerType: PropTypes.string
};

export default Layout;
